<script setup>
// eslint-disable-next-line vue/require-prop-types
const props = defineProps(['title', 'bgColor', 'color', 'padding', 'textSize']);

// Console.log(props.title)
</script>

<template>
  <span
    :style="`background-color: ${props.bgColor}; color: ${props.color}`"
    :class="[padding, textSize, 'font-semibold']"
  >{{
    props.title
  }}</span>
</template>

<style scoped></style>
